module.exports = ".instruction-box p {\n  margin-bottom: 15px;\n  font-size: 22px;\n  line-height: 30px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/update-first-time/update-first-time.component.scss
// module id = ./src/app/update-first-time/update-first-time.component.scss
// module chunks = main